<ng-container *ngIf="(betslipResultState$ | async)?.result.slips.length > 0 && (betslipResultState$ | async) as resultState">
    <bs-digital-result
        *ngIf="!isLinear; else linearResultTemplate"
        [state]="resultState"
        [trackingInformation]="betslipResultTrackingLocation"
        [inColumn]="inColumn"
        [oddsDisplayFormat]="oddsDisplayFormat"></bs-digital-result>

    <ng-template #linearResultTemplate>
        <bs-digital-linear-result [state]="resultState" [inColumn]="inColumn" [oddsDisplayFormat]="oddsDisplayFormat"> </bs-digital-linear-result>
    </ng-template>
</ng-container>
